// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#chat[data-v-4a6552f5]{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0}.user-details-enter[data-v-4a6552f5],.user-details-leave-to[data-v-4a6552f5]{width:0!important}", ""]);
// Exports
module.exports = exports;
